/** Hostname a partir de URL ou detail de browse (`host · termo`). */
export function resolveSiteHost(
  detail?: string,
  href?: string
): string | undefined {
  if (href) {
    try {
      return new URL(href).hostname.replace(/^www\./i, '');
    } catch {
      /* fall through */
    }
  }

  const value = detail?.trim();
  if (!value) return undefined;

  const absolute = value.match(/https?:\/\/([^/\s·]+)/i);
  if (absolute?.[1]) {
    return absolute[1].replace(/^www\./i, '');
  }

  const head = value.split(' · ')[0]?.trim() ?? '';
  const hostMatch = head.match(/^([\w.-]+\.[a-z]{2,})/i);
  if (hostMatch?.[1]) {
    return hostMatch[1].replace(/^www\./i, '');
  }

  return undefined;
}

export function faviconUrlForHost(host?: string): string | undefined {
  const normalized = host?.trim();
  if (!normalized) return undefined;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(
    normalized
  )}&sz=32`;
}

export function faviconUrlForUrl(url?: string | null): string | undefined {
  if (!url?.trim()) return undefined;
  try {
    const host = new URL(url).hostname.replace(/^www\./i, '');
    return faviconUrlForHost(host);
  } catch {
    return undefined;
  }
}

export function isExternalHttpUrl(url?: string | null): boolean {
  if (!url?.trim()) return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
